import React from 'react';
import styles from './EmptyProject.module.css';
export default function EmptyProject() {
    return (React.createElement("div", { className: styles.container },
        React.createElement("span", { className: styles.text }, "This prototype is empty. Add some images first!")));
}
